













import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import IAccount from '@/models/IAccount'
import ITransaction from '@/models/ITransaction'
import IUser from '@/models/IUser'
import accountService from '@/services/AccountService'
import transactionService from '@/services/TransactionService'
import mapService from '@/services/MapService'

const today: Date = new Date()

@Component({
  components: {
    'transaction-create': () => import('@/components/TransactionCreate.vue')
  }
})
export default class TransactionNew extends Vue {
  @Getter
  public user!: IUser | null
  @Prop({ type: String, required: true })
  public id!: string
  public account: IAccount | null = null
  public transaction: ITransaction | null = null

  public async created(): Promise<void> {
    if (this.id) {
      this.account = await accountService.get(this.id)
      if (this.account) {
        this.transaction = await transactionService.getNew(
          this.user,
          this.account
        )
      }

      try {
        if (!this.transaction) {
          return
        }
        const location = await mapService.getPosition()

        if (!location) {
          return
        }
        this.$set(this.transaction, 'location', { ...location })
      } catch (error) {
        // tslint:disable-next-line: no-console
        console.error(error)
      }
    }
  }
}
